import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import styled from "styled-components";

import * as departmentActions from "../../actions/departmentActions";
import * as serviceActions from "../../actions/serviceActions";

import { generateUniqueId } from "../../utils";

import DepartmentFormRow from "./DepartmentFormRow";

const DepartmentForm = ({ actions, department, services, onClose, onSave }) => {
  const [inputs, setInputs] = useState(department);

  useEffect(() => {
    const getServices = async () => {
      await actions.loadServices();
    };
    if (!services?.length) {
      getServices();
    }
  }, [services, actions]);

  const handleChange = (name, selected) => {
    setInputs({ ...inputs, [name]: selected?.value });
  };

  const handleSubmit = async () => {
    if (inputs.default_service?._id) {
      inputs.default_service = inputs.default_service?._id;
    }
    if (inputs.default_task?._id) {
      inputs.default_task = inputs.default_task?._id;
    }
    await actions.updateDepartment(inputs._id, inputs);
    onSave();
  };

  const departmentServices = services?.filter(
    (service) => service?.department?._id === department?._id
  );

  const selectedService = departmentServices?.filter(
    (service) =>
      service.id === inputs?.default_service?._id ||
      service.id === inputs?.default_service
  )?.[0];

  const isDisabled =
    !inputs.description || !inputs?.code || !inputs?.call_center_code;

  return (
    <Formsy className="vertical form" onValidSubmit={handleSubmit}>
      <DepartmentFormRow
        inputs={inputs}
        services={departmentServices}
        tasks={selectedService?.tasks}
        onChange={handleChange}
      />
      {inputs.sub_departments?.length ? (
        <React.Fragment>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div style={{ width: "20rem" }}>
              <StyledSectionText>Sub Department(s)</StyledSectionText>
            </div>
            <StyledDivider />
          </div>

          {inputs.sub_departments.map((subDept) => (
            <DepartmentFormRow
              key={generateUniqueId()}
              inputs={subDept}
              isSubDepartment
            />
          ))}
        </React.Fragment>
      ) : null}

      <Row>
        <Col md={12} xs={12} className="footer">
          <button className="btn btn-cancel" type="button" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            type="submit"
            disabled={isDisabled}
          >
            Save
          </button>
        </Col>
      </Row>
    </Formsy>
  );
};

const StyledSectionText = styled.h4`
  color: ${(props) => props.theme.blue_g};
`;

const StyledDivider = styled.div`
  height: 0.25rem;
  background-color: ${(props) => props.theme.blue_g};
  width: 100%;
  margin-left: auto;
`;

DepartmentForm.propTypes = {
  actions: PropTypes.object,
  services: PropTypes.array,
  department: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func
};

function mapStatesToProps(state) {
  return {
    services: state.reducers.services,
    tasks: state.reducers.tasks
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...serviceActions,
        ...departmentActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(DepartmentForm);
